module.exports = false;


//////////////////
// WEBPACK FOOTER
// /var/www/ras.universarium.org/www/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0